import React from 'react';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { PerformanceSummary } from '../../../PerformanceSummary/PerformanceSummary';
import { GrossOfFeeIcon } from '../../../GrossOfFeeIcon/GrossOfFeeIcon';

interface Props {
  title: string;
}

export const PerformanceSummaryCard = React.memo(({ title }: Props) => {
  return (
    <Card display="flex" flexDirection="column" maxHeight={400} pt="12" pb="24">
      <Text variant="cardTitle" mb="24" px="16">
        {title}
        <GrossOfFeeIcon />
      </Text>

      <Box px="16" flex={1} css="overflow-y: auto">
        <PerformanceSummary />
      </Box>
    </Card>
  );
});
